module.exports = __webpack_public_path__ + "img/logo-banner.4d880737.png";